import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "maritime-law.webp",
    title: "Maritime Law",
    crumb: "Maritime Law",
  },
  icon: "fa-solid fa-gavel",
  shortDescription:
    "Specialized legal advice in maritime operations, contracts, and regulatory compliance.",

  title: "Maritime Law",
  features: {
    title: "Maritime Law",
    reqDocuments: "Required Documents",
    deliverables: "Deliverables",
    subtitle:
      "Specialized legal advice in maritime operations, contracts, and regulatory compliance.",
    description: `Comprehensive advice in Maritime Law: drafting and negotiation of contracts, registry procedures, chartering, due diligence in purchase/sale, and maritime labor advice.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "contracts",
        title: "Tailored drafting and negotiation of maritime contracts",
        summary:
          "Contracts (charter, agency, repair, port services) with liability clauses, insurance, and arbitration.",
        details:
          "Custom drafting, review of critical clauses (laytime, demurrage, P&I, force majeure), negotiation and proposal of alternatives to mitigate risks.",
        deliverables: [
          "Legal draft (Word/PDF)",
          "Executive summary of critical clauses",
          "Risk checklist",
        ],
        requiredDocs: [
          "Party data",
          "Previous commercial terms",
          "Technical documentation of the operation",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.services + "editorial.jpeg",
      },
      {
        key: "registry",
        title: "Management and procedures before the Venezuelan Naval Registry",
        summary:
          "Registration, transfers, encumbrance annotations, and document management before the Naval Registry.",
        details:
          "Preparation of file, submission to authority, follow-up and obtaining of registry certificates; coordination with experts and technicians if necessary.",
        deliverables: [
          "File ready",
          "Filing receipt",
          "Final certificate delivered",
        ],
        requiredDocs: [
          "Title deeds",
          "Notarial powers",
          "Technical certificates of the vessel",
        ],
        icon: "fa-solid fa-passport",
        image: global.services + "consulting.webp",
      },
      {
        key: "charter",
        title: "Advice on chartering (time & voyage charter)",
        summary:
          "Negotiation and drafting of charter contracts, laytime calculation, and handling of demurrage claims.",
        details:
          "Advice on choosing type of charter, drafting operational clauses, laytime/demurrage calculation and examples, and notification procedures.",
        deliverables: [
          "Charter contract/clauses",
          "Laytime calculation example",
          "Claims management procedure",
        ],
        requiredDocs: [
          "Planned itinerary",
          "Vessel documentation",
          "Commercial conditions",
        ],
        icon: "fa-solid fa-anchor",
        image: global.services + "management.jpg",
      },
      {
        key: "purchase",
        title: "Purchase and sale of vessels: due diligence and contract",
        summary:
          "Legal and technical due diligence, SPA drafting, escrow management, and registry transfer.",
        details:
          "Verification of encumbrances, technical certificates, maintenance history; coordination of inspections and indemnity and escrow clauses in the contract.",
        deliverables: [
          "Due diligence report",
          "Purchase draft",
          "Transfer plan",
        ],
        requiredDocs: [
          "Registry titles",
          "Maintenance history",
          "Technical certificates",
        ],
        icon: "fa-solid fa-ship",
        image: global.services + "purchase.jpeg",
      },
      {
        key: "labor",
        title: "Advice on maritime labor law and conflict resolution",
        summary:
          "Crew contracts, labor claims, compliance with conventions, and representation in disputes.",
        details:
          "Drafting of maritime labor contracts, claim protocols, representation in administrative and judicial proceedings, preventive management of labor risks on board.",
        deliverables: [
          "Labor contract template",
          "Claim procedure",
          "Support in negotiations",
        ],
        requiredDocs: [
          "Current contracts",
          "Competency certificates",
          "Incident history",
        ],
        icon: "fa-solid fa-people-roof",
        image: global.services + "labor-law.jpg",
      },
    ],
  },
  ctaText: "Request legal advice",
  ctaLink: "/contact?service=maritime-law",
};
